import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { Api } from '@/externals/corner-logis/Swagger';

import { CornerLogis } from '../../helpers';

export const 코너로지스_상품_반출_쿼리 = createQueryKeys('corner-logis-product-carrying-out', {
  상품_반출_목록_조회: ({ shopID, query }: { shopID: string; query: Api.GetPageList1.RequestQuery }) => ({
    queryKey: [shopID, query] as const,
    queryFn: () => {
      return CornerLogis.proxy<Api.GetPageList1.ResponseBody>({
        method: 'GET',
        path: '/api/v1/bulkOutbound/getList',
        params: query,
        shopID,
      });
    },
  }),

  상품_반출_등록_가능일_조회: ({
    shopID,
    query,
  }: {
    shopID: string;
    query: Api.GetAvailableDateList.RequestQuery;
  }) => ({
    queryKey: [shopID, query] as const,
    queryFn: () => {
      return CornerLogis.proxy<Api.GetAvailableDateList.ResponseBody>({
        method: 'GET',
        path: '/api/v1/bulkOutbound/getAvailableDate',
        params: query,
        shopID,
      });
    },
  }),
});
